module.exports = __webpack_public_path__ + "img/background-success.99c1c91f.svg";